export default __webpack_public_path__ + "img/TourStep11.png";